import { initializeApp } from "firebase/app";
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
  HttpsCallableOptions,
} from "firebase/functions";
import { connectAuthEmulator, getAuth } from "firebase/auth";

// Local development only (same flags as BOH's src/firebase.ts): the emulators,
// under a throwaway demo project so nothing can reach production.
const useEmulators =
  process.env.NODE_ENV !== "production" &&
  process.env.REACT_APP_USE_EMULATOR === "true";
const emulatorProjectId = useEmulators
  ? process.env.REACT_APP_EMULATOR_PROJECT_ID
  : undefined;

const firebaseConfig = {
  apiKey: "AIzaSyAY4sn4nb2t5XF2Kn54yuHzmFLwyQnwJ-U",
  authDomain: "sally-pos.firebaseapp.com",
  projectId: emulatorProjectId || "sally-pos",
  messagingSenderId: "53424846418",
  appId: "1:53424846418:web:f017d405befc737641518b",
  measurementId: "G-F2117GRGZ2",
};

// Under a demo project the functions emulator registers them in us-central1.
const REGION = emulatorProjectId?.startsWith("demo-")
  ? "us-central1"
  : "europe-west1";

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const functions = getFunctions(app, REGION);

function getAPI<TReq = unknown, TRes = unknown>(
  name: string,
  options?: HttpsCallableOptions,
) {
  return httpsCallable<TReq, TRes>(
    functions,
    `v2-products-customerOrdering-${name}`,
    options,
  );
}

/** @deprecated use getAPI */
const api = getAPI;

// Local development against the Firebase emulators (see
// docs/FIREBASE_EMULATORS.md). Same ports as the BOH.
if (useEmulators) {
  const port = (name: string, fallback: number) =>
    Number(process.env[`REACT_APP_${name}_EMULATOR_PORT`] || fallback);

  connectAuthEmulator(auth, `http://localhost:${port("AUTH", 9099)}`, {
    disableWarnings: true,
  });
  connectFunctionsEmulator(functions, "localhost", port("FUNCTIONS", 5001));
  console.log("🔥 Using Firebase emulators");
}

// Only Auth and Functions: everything else goes through the callables.
export { auth, functions, getAPI, api };

export default app;
